import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var NoResults = function NoResults() {
  var getClassName = getClassNameFactory("SearchResults");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "noResults"
    })
  }, /*#__PURE__*/React.createElement("h3", {
    className: getClassName({
      descendantName: "noResultsTitle"
    })
  }, "Suggestions"), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "noResultsItems"
    })
  }, /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "noResultsItem"
    })
  }, "Check your spelling"), /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "noResultsItem"
    })
  }, "Try fewer words"), /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "noResultsItem"
    })
  }, "Try more general keywords")));
};

NoResults.displayName = "SearchResults.NoResults";
export default NoResults;